import React from 'react'
import AnimateImageSix from './AnimateImageSix'
import AnimateTitleSix from './AnimatedTitleSix'

const QualityControl = () => {
    return (
        <section className='section-quality-control section-padding'>
            <div className='container'>
                <div className='row'>
                <div className='col-md-8 offset-md-2'>
                    <div className='section-img-heading'>
                        <div className='section-title'>
                        <AnimateTitleSix/>
                     </div>
                    <div className='animated-image-wrapper'>
                        <AnimateImageSix/>
                    </div>
                    </div>
                   <div className='section-content-wrapper'>
                     <div className='section-paragraph'>
                        <p>Excellence is non-negotiable. Each garment undergoes a detailed inspection for embroidery quality, stitching accuracy, and finishing standards. Any inconsistencies are corrected with care and attention, ensuring that every piece leaving our facility upholds the reputation of our craftsmanship. This meticulous approach to quality assurance ensures our clients receive only the finest creations, ready for global runways and luxury boutiques.</p>
                     </div>
                   </div>
                </div>
                </div>
            </div>
        </section>
    )
}

export default QualityControl